import { render, staticRenderFns } from "./booking-form-controller.vue?vue&type=template&id=0b24067f"
import script from "./booking-form-controller.vue?vue&type=script&lang=js"
export * from "./booking-form-controller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports